module.exports = __webpack_public_path__ + "static/img/p1-2-0.eda228b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-2-0.png
// module id = 8tTY
// module chunks = 0